"use client";

import { useLocale, useTranslations } from "next-intl";
import { Link } from "next-view-transitions";
import { FEATURES } from "@/components/navbar/features-menu";
import { Heading } from "./heading";
import { Subheading } from "./subheading";

export const GridFeatures = () => {
  const t = useTranslations("grid");
  const fm = useTranslations("featuresMenu");
  const locale = useLocale();

  return (
    <div className="relative z-20 py-10 lg:py-32 w-full">
      <Heading as="h2">{t("heading")}</Heading>
      <Subheading className="text-center">{t("subheading")}</Subheading>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {FEATURES.map((f) => (
          <Link
            key={f.slug}
            href={`/${locale}/features/${f.slug}`}
            className="group rounded-2xl border border-neutral-800 bg-neutral-900/40 p-5 md:p-6 transition-colors hover:border-neutral-600 hover:bg-neutral-900"
          >
            <div className="flex items-center gap-3">
              <span className="text-red-500">{f.icon}</span>
              <h3 className="text-base md:text-lg font-semibold text-white tracking-tight">
                {fm(f.titleKey)}
              </h3>
            </div>
            <p className="mt-2 text-sm text-neutral-400 leading-relaxed">
              {fm(f.descKey)}
            </p>
          </Link>
        ))}
      </div>
    </div>
  );
};
